(function mountHeroVideo() {
  const mount = document.querySelector('[data-nv-hero-video-mount]');
  if (!mount) return;

  const isDesktop = window.matchMedia('(min-width: 980px)').matches;
  const preferred = isDesktop ? 'desktop' : 'mobile';
  const fallback = isDesktop ? 'mobile' : 'desktop';

  const template =
    document.querySelector(`[data-nv-hero-video="${preferred}"]`) ||
    document.querySelector(`[data-nv-hero-video="${fallback}"]`);

  if (!template) return;

  mount.appendChild(template.content.cloneNode(true));

  const clonedVideo = mount.querySelector('video');
  if (clonedVideo) {
    clonedVideo.play().catch(() => {
      // Autoplay blocked — video will show its poster/first frame instead,
      // no error surfaced to the user.
    });
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuToggles = Array.from(document.querySelectorAll('[data-nv-mobile-menu-toggle]'));
  const mobileMenuPanels = Array.from(document.querySelectorAll('[data-nv-mobile-menu]'));
  const mobileMenuCloseTargets = Array.from(document.querySelectorAll('[data-nv-mobile-menu-close], [data-nv-mobile-menu-link]'));

  function setMobileMenuOpen(isOpen) {
    document.body.classList.toggle('nv-mobile-menu-open', isOpen);
    mobileMenuToggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
    mobileMenuPanels.forEach((panel) => {
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  mobileMenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const isOpen = document.body.classList.contains('nv-mobile-menu-open');
      setMobileMenuOpen(!isOpen);
    });
  });

  mobileMenuCloseTargets.forEach((target) => {
    target.addEventListener('click', () => setMobileMenuOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMobileMenuOpen(false);
  });

  const pricingModules = document.querySelectorAll('[data-nv-pricing-module]');
  const cartDrawer = document.querySelector('[data-nv-cart-drawer]');
  const cartDrawerContent = document.querySelector('[data-nv-cart-drawer-content]');
  const cartDrawerSubtotal = document.querySelector('[data-nv-cart-drawer-subtotal]');
  const cartDrawerCloses = Array.from(document.querySelectorAll('[data-nv-cart-drawer-close]'));
  const cartDrawerOpenTriggers = Array.from(document.querySelectorAll('[data-nv-cart-drawer-open]'));
  const cartCountBadges = Array.from(document.querySelectorAll('[data-nv-cart-count]'));
  const cartForm = document.querySelector('.nv-cart__form');

  function formatMoney(cents, format = '€{{amount}}') {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace('{{amount}}', value);
  }

  function formatMoneyTrimmed(cents) {
    return formatMoney(cents).replace(/,00$/, '');
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nv-cart-drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nv-cart-drawer-open');
  }

  cartDrawerCloses.forEach((btn) => btn.addEventListener('click', closeCartDrawer));

  function escHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  async function renderCartDrawer() {
    if (!cartDrawerContent) return null;
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) return null;
    const cart = await response.json();
    if (cartDrawerSubtotal) {
      cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
    }

    if (!cart.items || cart.items.length === 0) {
      cartDrawerContent.innerHTML = '<p class="nv-cart-drawer__empty">Your cart is empty.</p>';
      return cart;
    }

    const itemsHtml = cart.items.map((item) => {
      const plan = item.selling_plan_allocation?.selling_plan?.name;
      return `
        <div class="nv-cart-drawer__item" data-line="${escHtml(item.key)}">
          <div class="nv-cart-drawer__media">
            ${item.image ? `<img src="${escHtml(item.image)}" alt="${escHtml(item.product_title)}">` : ''}
          </div>
          <div class="nv-cart-drawer__info">
            <div class="nv-cart-drawer__meta">
              <p class="nv-cart-drawer__product">${escHtml(item.product_title)}</p>
              <p class="nv-cart-drawer__variant">${escHtml(item.variant_title || '')}</p>
              ${plan ? `<p class="nv-cart-drawer__plan">${escHtml(plan)}</p>` : ''}
            </div>
            <div class="nv-cart-drawer__qty">
              <button type="button" data-nv-cart-qty="minus">-</button>
              <span>${escHtml(item.quantity)}</span>
              <button type="button" data-nv-cart-qty="plus">+</button>
            </div>
            <button type="button" class="nv-cart-drawer__remove" data-nv-cart-remove>Remove</button>
          </div>
          <div class="nv-cart-drawer__price">${formatMoney(item.final_line_price)}</div>
        </div>
      `;
    }).join('');

    cartDrawerContent.innerHTML = itemsHtml;
    return cart;
  }

  async function updateCartCount() {
    if (!cartCountBadges.length) return;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      const count = cart.item_count || 0;
      cartCountBadges.forEach((badge) => {
        badge.textContent = count > 0 ? String(count) : '';
      });
    } catch (err) {
      // no-op
    }
  }

  cartDrawerOpenTriggers.forEach((btn) => {
    btn.addEventListener('click', async () => {
      await renderCartDrawer();
      openCartDrawer();
    });
  });

  updateCartCount();

  async function changeCartLine(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) return null;
    const cart = await response.json();
    await renderCartDrawer();
    await updateCartCount();
    return cart;
  }

  if (cartDrawerContent) {
    cartDrawerContent.addEventListener('click', (event) => {
      const itemEl = event.target.closest('.nv-cart-drawer__item');
      if (!itemEl) return;
      const key = itemEl.getAttribute('data-line');
      if (!key) return;

      if (event.target.matches('[data-nv-cart-remove]')) {
        changeCartLine(key, 0);
        return;
      }

      if (event.target.matches('[data-nv-cart-qty="plus"]')) {
        const qtyEl = itemEl.querySelector('.nv-cart-drawer__qty span');
        const currentQty = parseInt(qtyEl?.textContent || '1', 10);
        changeCartLine(key, currentQty + 1);
        return;
      }

      if (event.target.matches('[data-nv-cart-qty="minus"]')) {
        const qtyEl = itemEl.querySelector('.nv-cart-drawer__qty span');
        const currentQty = parseInt(qtyEl?.textContent || '1', 10);
        changeCartLine(key, Math.max(1, currentQty - 1));
      }
    });
  }

  if (cartForm) {
    cartForm.addEventListener('click', async (event) => {
      const isPlus = event.target.matches('[data-nv-qty-plus]');
      const isMinus = event.target.matches('[data-nv-qty-minus]');
      if (!isPlus && !isMinus) return;

      const itemEl = event.target.closest('.nv-cart__item');
      if (!itemEl) return;
      const key = itemEl.getAttribute('data-nv-line');
      if (!key) return;

      const qtyInput = itemEl.querySelector('.nv-cart__qty-input');
      const qtyButtons = itemEl.querySelectorAll('[data-nv-qty-plus], [data-nv-qty-minus]');
      const previousQty = parseInt(qtyInput?.value || '1', 10);
      const newQty = isPlus ? previousQty + 1 : Math.max(0, previousQty - 1);

      // Optimistic update: reflect the new quantity and lock the row immediately,
      // before the network round-trip, so the click feels instant.
      if (qtyInput) qtyInput.value = newQty;
      itemEl.classList.add('nv-cart__item--pending');
      qtyButtons.forEach((btn) => { btn.disabled = true; });

      const cart = await changeCartLine(key, newQty);

      if (!cart) {
        if (qtyInput) qtyInput.value = previousQty;
        itemEl.classList.remove('nv-cart__item--pending');
        qtyButtons.forEach((btn) => { btn.disabled = false; });
        console.warn('Novelius: failed to update cart quantity for line', key);
        return;
      }

      if (newQty === 0) {
        itemEl.remove();
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
      } else {
        const updatedItem = cart.items.find((cartItem) => cartItem.key === key);
        const priceEl = itemEl.querySelector('[data-nv-line-price]');
        if (priceEl && updatedItem) {
          priceEl.textContent = formatMoneyTrimmed(updatedItem.final_line_price);
        }
        itemEl.classList.remove('nv-cart__item--pending');
        qtyButtons.forEach((btn) => { btn.disabled = false; });
      }

      const subtotalEl = cartForm.querySelector('[data-nv-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoneyTrimmed(cart.total_price);
    });
  }

  pricingModules.forEach((module) => {
    const toggles = Array.from(module.querySelectorAll('[data-nv-toggle]'));
    const optionsContainer = module.querySelector('[data-nv-pricing-options]');
    const offerSelectButtons = Array.from(module.querySelectorAll('[data-nv-offer-select]'));
    const offers = Array.from(module.querySelectorAll('[data-nv-offer]'));
    const productForm = module.querySelector('.nv-product-form');
    const variantInput = productForm?.querySelector('input[name="id"]');
    const sellingPlanInput = productForm?.querySelector('input[name="selling_plan"]');
    const returnToInput = productForm?.querySelector('input[name="return_to"]');
    const mainCta = module.querySelector('[data-nv-main-cta]');
    const ctaPrefix = mainCta?.dataset.nvCtaPrefix || '';
    const availabilityText = module.querySelector('[data-nv-availability-text]');
    const defaultAvailabilityText = availabilityText?.textContent?.trim() || 'In stock';
    const ctaNote = module.querySelector('[data-nv-cta-note]');
    const ctaSavingsNote = module.querySelector('[data-nv-cta-savings-note]');
    const mainCarousel = module.querySelector('[data-nv-main-carousel]');
    const mainTrack = module.querySelector('[data-nv-main-track]');
    const slides = Array.from(module.querySelectorAll('[data-nv-main-slide]'));
    const thumbs = Array.from(module.querySelectorAll('.nv-thumb[data-nv-slide-index]'));
    const thumbsRail = module.querySelector('[data-nv-thumbs]');
    const thumbsNext = module.querySelector('[data-nv-thumbs-next]');
    const descriptionBlock = module.querySelector('[data-nv-description]');
    const readMoreButton = module.querySelector('[data-nv-read-more]');
    const isMobileGallery = () => window.matchMedia('(max-width: 760px)').matches;
    let activeSlide = 0;

    function setActiveThumb(index) {
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      activeSlide = index;
    }

    function goToSlide(index, smooth = true) {
      if (!slides.length) return;
      const next = Math.max(0, Math.min(index, slides.length - 1));
      setActiveThumb(next);

      if (isMobileGallery() && mainCarousel) {
        const left = slides[next].offsetLeft;
        mainCarousel.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        return;
      }

      if (mainTrack) {
        mainTrack.style.transform = `translateX(-${next * 100}%)`;
      }
    }

    if (thumbs.length && slides.length) {
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          goToSlide(i, true);
          if (thumbsRail && typeof thumb.scrollIntoView === 'function') {
            thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });
      goToSlide(0, false);
    }

    if (thumbsRail && thumbsNext) {
      thumbsNext.addEventListener('click', () => {
        if (!thumbs.length) return;
        const nextIndex = (activeSlide + 1) % thumbs.length;
        const nextThumb = thumbs[nextIndex];
        if (!nextThumb) return;
        goToSlide(nextIndex, true);
        if (typeof nextThumb.scrollIntoView === 'function') nextThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });

      const canScroll = thumbsRail.scrollWidth > thumbsRail.clientWidth + 2;
      if (!canScroll && thumbs.length < 2) {
        thumbsNext.style.display = 'none';
      } else {
        thumbsNext.style.display = 'inline-flex';
      }
    }

    if (thumbsRail) {
      // Prevent accidental vertical scrolling while swiping over the thumb rail.
      thumbsRail.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        thumbsRail.scrollLeft += event.deltaY;
      }, { passive: false });
    }

    if (thumbsRail && thumbs.length) {
      const syncOnResize = () => {
        const canScroll = thumbsRail.scrollWidth > thumbsRail.clientWidth + 2;
        if (!canScroll && thumbs.length < 2) {
          if (thumbsNext) thumbsNext.style.display = 'none';
          return;
        }
        if (thumbsNext) thumbsNext.style.display = 'inline-flex';
      };
      syncOnResize();
      window.addEventListener('resize', syncOnResize);
    }

    if (mainCarousel && slides.length) {
      let ticking = false;
      mainCarousel.addEventListener('scroll', () => {
        if (!isMobileGallery()) return;
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const width = mainCarousel.clientWidth || 1;
          const index = Math.round(mainCarousel.scrollLeft / width);
          if (index !== activeSlide) setActiveThumb(Math.max(0, Math.min(index, slides.length - 1)));
          ticking = false;
        });
      }, { passive: true });
    }

    if (!optionsContainer) return;

    if (descriptionBlock && readMoreButton) {
      const readMoreLabel = readMoreButton.dataset.nvReadMoreLabel || 'Read more';
      const readLessLabel = readMoreButton.dataset.nvReadLessLabel || 'Read less';
      readMoreButton.addEventListener('click', () => {
        const isExpanded = descriptionBlock.classList.toggle('is-expanded');
        readMoreButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        readMoreButton.textContent = isExpanded ? readLessLabel : readMoreLabel;
      });
    }

    function setMode(mode) {
      if (!toggles.length) return;
      toggles.forEach((toggle) => {
        const active = toggle.dataset.nvToggle === mode;
        toggle.classList.toggle('is-active', active);
        toggle.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      optionsContainer.setAttribute('data-nv-plan-mode', mode);
    }

    const initialSelectedOffer = optionsContainer?.dataset?.nvSelectedOffer || 'most-flexible';
    let currentSelectedOffer = initialSelectedOffer;

    function setSelectedOffer(offer, shouldScroll = false) {
      const selected = offer === 'one-time' ? 'one-time' : offer;
      optionsContainer.setAttribute('data-nv-selected-offer', selected);
      currentSelectedOffer = selected;

      offers.forEach((offerEl) => {
        offerEl.classList.toggle('is-selected', offerEl.dataset.nvOffer === selected);
      });

      if (offer === 'best-value' || offer === 'most-flexible') {
        setMode(offer);
      }

      if (shouldScroll && (offer === 'best-value' || offer === 'most-flexible')) {
        const target = module.querySelector(`[data-nv-offer=\"${offer}\"]`);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      const activeOffer = module.querySelector(`[data-nv-offer=\"${selected}\"]`);
      if (!activeOffer) return;

      if (variantInput && activeOffer.dataset.nvVariantId) {
        variantInput.value = activeOffer.dataset.nvVariantId;
      }

      if (sellingPlanInput) {
        sellingPlanInput.value = activeOffer.dataset.nvSellingPlanId || '';
      }

      if (mainCta) {
        const customLabel = activeOffer.dataset.nvCtaLabel;
        if (customLabel) {
          mainCta.textContent = customLabel;
        } else {
          const offerPrice = activeOffer.dataset.nvPrice || '';
          mainCta.textContent = `${ctaPrefix}${offerPrice}`;
        }
      }

      if (ctaSavingsNote) {
        const savingsText = activeOffer.dataset.nvSavingsNote || '';
        if (savingsText) {
          ctaSavingsNote.textContent = savingsText;
          ctaSavingsNote.hidden = false;
        } else {
          ctaSavingsNote.hidden = true;
        }
      }

      if (ctaNote) {
        const needsPlan = selected === 'most-flexible';
        const hasPlan = !!activeOffer.dataset.nvSellingPlanId;
        ctaNote.hidden = !(needsPlan && !hasPlan);
      }

      const isAvailable = activeOffer.dataset.nvAvailable !== 'false';
      if (mainCta) {
        const needsPlan = selected === 'most-flexible';
        const hasPlan = !!activeOffer.dataset.nvSellingPlanId;
        const canPurchase = isAvailable && (!needsPlan || hasPlan);
        mainCta.disabled = !canPurchase;
        mainCta.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
      }

      if (availabilityText) {
        availabilityText.textContent = isAvailable ? defaultAvailabilityText : 'Out of stock';
      }
    }

    function resetCtaLoading() {
      if (!mainCta) return;
      if (mainCta.dataset.nvOriginalLabel) {
        mainCta.textContent = mainCta.dataset.nvOriginalLabel;
      }
      mainCta.classList.remove('is-loading');
      mainCta.removeAttribute('aria-busy');
      mainCta.disabled = false;
      mainCta.setAttribute('aria-disabled', 'false');
    }

    async function routeToCheckoutOrCart(event) {
      if (!productForm || !returnToInput || !mainCta) return;
      event.preventDefault();

      mainCta.disabled = true;
      mainCta.setAttribute('aria-disabled', 'true');
      mainCta.setAttribute('aria-busy', 'true');
      mainCta.classList.add('is-loading');
      if (!mainCta.dataset.nvOriginalLabel) {
        mainCta.dataset.nvOriginalLabel = mainCta.textContent || '';
      }
      mainCta.textContent = mainCta.dataset.nvLoadingLabel || 'Adding…';

      let targetPath = '/checkout';
      try {
        const formData = new FormData(productForm);
        const selectedOffer = currentSelectedOffer || optionsContainer?.dataset.nvSelectedOffer || '';
        const activeOffer =
          module.querySelector('.nv-option.is-selected') ||
          module.querySelector(`[data-nv-offer="${selectedOffer}"]`) ||
          offers[0];
        const desiredPlanId = activeOffer?.dataset?.nvSellingPlanId || '';
        const desiredVariantId = activeOffer?.dataset?.nvVariantId || '';

        if (desiredVariantId) {
          formData.set('id', desiredVariantId);
        }

        // Remove any selling_plan values unless subscription is selected.
        formData.delete('selling_plan');
        if (desiredPlanId) {
          formData.set('selling_plan', desiredPlanId);
        }

        // Ensure quantity is at least 1.
        if (!formData.has('quantity')) formData.set('quantity', '1');
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!addResponse.ok) throw new Error('cart add failed');
        await updateCartCount();
        const cart = cartDrawer ? await renderCartDrawer() : null;
        let resolvedCart = cart;
        if (!resolvedCart) {
          const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
          if (!cartResponse.ok) throw new Error('cart fetch failed');
          resolvedCart = await cartResponse.json();
        }
        const hasItems = (resolvedCart?.item_count || 0) > 1;
        targetPath = hasItems ? '/cart' : '/checkout';
        returnToInput.value = targetPath;

        if (targetPath === '/checkout') {
          resetCtaLoading();
          window.location.href = '/checkout';
          return;
        }
        if (cartDrawer) {
          await renderCartDrawer();
          openCartDrawer();
          resetCtaLoading();
        } else {
          resetCtaLoading();
          window.location.href = '/cart';
        }
        return;
      } catch (err) {
        // Fallback to checkout if cart state is unavailable.
        targetPath = '/checkout';
        returnToInput.value = targetPath;
      }

      resetCtaLoading();

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => setSelectedOffer(toggle.dataset.nvToggle, true));
    });

    offerSelectButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const offer = button.dataset.nvOfferSelect;
        if (!offer) return;
        setSelectedOffer(offer, false);
      });
    });

    offers.forEach((offerEl) => {
      offerEl.addEventListener('click', (event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.closest('[data-nv-offer-select], .nv-btn, .nv-delivery-select')) return;
        const offer = offerEl.dataset.nvOffer;
        if (!offer) return;
        setSelectedOffer(offer, false);
      });
    });

    if (mainCta && productForm) {
      mainCta.addEventListener('click', routeToCheckoutOrCart);
    }

    setSelectedOffer(initialSelectedOffer);
  });

  function runJudgemeHealthChecks() {
    const badgeNodes = Array.from(document.querySelectorAll('.nv-judgeme-badge'));
    const reviewWidgets = Array.from(document.querySelectorAll('.nv-judgeme-reviews'));

    badgeNodes.forEach((badge) => {
      const hasBadgeMarkup = !!badge.querySelector('.jdgm-prev-badge, .jdgm-star');
      const hasVisibleStars = badge.textContent && badge.textContent.replace(/\s+/g, '').length > 0;
      if (!hasBadgeMarkup && !hasVisibleStars) {
        badge.classList.add('is-empty');
      }
    });

    reviewWidgets.forEach((widgetWrap) => {
      const hasWidgetMarkup = !!widgetWrap.querySelector('.jdgm-rev-widg, .jdgm-widget, .jdgm-rev');
      if (!hasWidgetMarkup) {
        widgetWrap.classList.add('is-empty');
      }
    });
  }

  setTimeout(runJudgemeHealthChecks, 1200);

  const mobileHeroMedia = window.matchMedia('(max-width: 760px)');

  function setStableMobileHeroHeight() {
    if (!mobileHeroMedia.matches) {
      document.documentElement.style.removeProperty('--nv-mobile-hero-height');
      return;
    }

    const heroPx = Math.max(window.innerHeight, window.screen.height || 0);
    if (heroPx > 0) {
      document.documentElement.style.setProperty('--nv-mobile-hero-height', `${heroPx}px`);
    }
  }

  setStableMobileHeroHeight();
  window.addEventListener('orientationchange', setStableMobileHeroHeight);
  window.addEventListener('resize', setStableMobileHeroHeight);
  mobileHeroMedia.addEventListener('change', setStableMobileHeroHeight);

  const productCarousels = document.querySelectorAll('[data-nv-product-carousel]');

  productCarousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-nv-product-track]');
    if (!track) return;

    const slides = Array.from(track.children);
    const parent = carousel.parentElement;
    const prev = parent?.querySelector('[data-nv-product-prev]');
    const next = parent?.querySelector('[data-nv-product-next]');
    const dots = Array.from(parent?.querySelectorAll('[data-nv-product-dot]') || []);
    let index = 0;

    if (slides.length < 2) return;

    function render() {
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      render();
    }

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    render();
  });

  const mobileReviewMedia = window.matchMedia('(max-width: 699px)');

  function initReviewCarousel() {
    if (!mobileReviewMedia.matches) return;

    const tracks = document.querySelectorAll('.nv-review-track');

    tracks.forEach((track) => {
      const cards = Array.from(track.children);
      if (cards.length < 2) return;

      const dots = Array.from(track.closest('.nv-container')?.querySelectorAll('[data-nv-review-dot]') || []);
      let index = 0;
      let timer = null;
      let resumeTimeout = null;
      let scrollRAF = null;

      function syncDotsFromScroll() {
        if (scrollRAF) return;
        scrollRAF = requestAnimationFrame(() => {
          scrollRAF = null;
          const cardWidth = track.clientWidth || 1;
          const nearest = Math.round(track.scrollLeft / cardWidth);
          index = Math.max(0, Math.min(cards.length - 1, nearest));
          dots.forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('nv-review-dot--active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      }

      function goTo(nextIndex) {
        index = (nextIndex + cards.length) % cards.length;
        track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(() => goTo(index + 1), 4500);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      track.addEventListener('scroll', syncDotsFromScroll, { passive: true });

      track.addEventListener('touchstart', () => {
        stopAuto();
        if (resumeTimeout) clearTimeout(resumeTimeout);
      }, { passive: true });

      track.addEventListener('touchend', () => {
        if (resumeTimeout) clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(startAuto, 2000);
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const dotIndex = parseInt(dot.getAttribute('data-nv-review-dot'), 10);
          if (Number.isNaN(dotIndex)) return;
          goTo(dotIndex);
          startAuto();
        });
      });

      syncDotsFromScroll();
      startAuto();
    });
  }

  initReviewCarousel();

  const mobileFwiMedia = window.matchMedia('(max-width: 760px)');

  function initFormulatedCarousel() {
    if (!mobileFwiMedia.matches) return;

    const tracks = document.querySelectorAll('.nv-fwi__track');

    tracks.forEach((track) => {
      const cards = Array.from(track.children);
      if (cards.length < 2) return;

      const dots = Array.from(track.closest('.nv-fwi__carousel')?.querySelectorAll('[data-nv-fwi-dot]') || []);
      let index = 0;
      let timer = null;
      let resumeTimeout = null;
      let scrollRAF = null;

      function syncDotsFromScroll() {
        if (scrollRAF) return;
        scrollRAF = requestAnimationFrame(() => {
          scrollRAF = null;
          const cardWidth = track.clientWidth || 1;
          const nearest = Math.round(track.scrollLeft / cardWidth);
          index = Math.max(0, Math.min(cards.length - 1, nearest));
          dots.forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('nv-fwi__dot--active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      }

      function goTo(nextIndex) {
        index = (nextIndex + cards.length) % cards.length;
        track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(() => goTo(index + 1), 4500);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      track.addEventListener('scroll', syncDotsFromScroll, { passive: true });

      track.addEventListener('touchstart', () => {
        stopAuto();
        if (resumeTimeout) clearTimeout(resumeTimeout);
      }, { passive: true });

      track.addEventListener('touchend', () => {
        if (resumeTimeout) clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(startAuto, 2000);
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const dotIndex = parseInt(dot.getAttribute('data-nv-fwi-dot'), 10);
          if (Number.isNaN(dotIndex)) return;
          goTo(dotIndex);
          startAuto();
        });
      });

      syncDotsFromScroll();
      startAuto();
    });
  }

  initFormulatedCarousel();

  function initExpertOpinionVideos() {
    const wraps = document.querySelectorAll('[data-nv-expert-video-wrap]');
    const allVideos = [];

    wraps.forEach((wrap) => {
      const video = wrap.querySelector('.nv-expert-video');
      const playBtn = wrap.querySelector('[data-nv-expert-play]');
      if (!video || !playBtn) return;

      allVideos.push(video);

      playBtn.addEventListener('click', () => {
        video.play();
      });

      // Hides the overlay and reveals native controls however playback starts
      // (manual click here, or the carousel's programmatic play() elsewhere) —
      // and if play() is blocked/rejected, no 'play' event fires, so the
      // button simply stays visible as the fallback, with no extra handling.
      video.addEventListener('play', () => {
        playBtn.classList.add('nv-is-hidden');
        video.controls = true;
      });
    });

    // Only one .nv-expert-video may play at a time, across every instance on the page.
    allVideos.forEach((video) => {
      video.addEventListener('play', () => {
        allVideos.forEach((other) => {
          if (other !== video && !other.paused) other.pause();
        });
      });
    });

    // Stop playback when the tab/page is hidden (navigated away, backgrounded,
    // switched tabs) so audio doesn't keep playing after the user has left.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        allVideos.forEach((video) => {
          if (!video.paused) video.pause();
        });
      }
    });
  }

  initExpertOpinionVideos();

  const mobileExpertMedia = window.matchMedia('(max-width: 760px)');

  function initExpertOpinionCarousel() {
    if (!mobileExpertMedia.matches) return;

    const tracks = document.querySelectorAll('.nv-expert-opinion__track');

    tracks.forEach((track) => {
      const cards = Array.from(track.children);
      if (cards.length < 2) return;

      const dots = Array.from(track.closest('.nv-expert-opinion__carousel')?.querySelectorAll('[data-nv-expert-dot]') || []);
      const videos = cards.map((card) => card.querySelector('.nv-expert-video'));
      let index = 0;
      let resumeTimeout = null;
      let scrollRAF = null;

      function syncDotsFromScroll() {
        if (scrollRAF) return;
        scrollRAF = requestAnimationFrame(() => {
          scrollRAF = null;
          const cardWidth = track.clientWidth || 1;
          const nearest = Math.round(track.scrollLeft / cardWidth);
          index = Math.max(0, Math.min(cards.length - 1, nearest));
          dots.forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('nv-expert-opinion__dot--active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      }

      // No wraparound: an out-of-range index is ignored, so the "ended" chain
      // stops on the last card instead of looping back to the first.
      function goTo(nextIndex) {
        if (nextIndex < 0 || nextIndex >= cards.length) return;
        index = nextIndex;
        track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      }

      function attemptPlay(video) {
        if (!video) return;
        try {
          const result = video.play();
          if (result && typeof result.catch === 'function') {
            result.catch(() => {
              // Autoplay blocked — leave that card's play button visible as a fallback.
            });
          }
        } catch (err) {
          // Autoplay blocked — leave that card's play button visible as a fallback.
        }
      }

      track.addEventListener('scroll', syncDotsFromScroll, { passive: true });

      track.addEventListener('touchstart', (event) => {
        // A touch on a video that already has native controls enabled is the
        // user interacting with the browser's own play/pause/scrub UI, not
        // swiping the carousel — don't fight it with the pause/resume timer.
        if (event.target.tagName === 'VIDEO' && event.target.controls) return;
        if (resumeTimeout) clearTimeout(resumeTimeout);
        const current = videos[index];
        if (current && !current.paused) current.pause();
      }, { passive: true });

      track.addEventListener('touchend', (event) => {
        if (event.target.tagName === 'VIDEO' && event.target.controls) return;
        if (resumeTimeout) clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(() => {
          const current = videos[index];
          if (current && current.paused) attemptPlay(current);
        }, 2000);
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const dotIndex = parseInt(dot.getAttribute('data-nv-expert-dot'), 10);
          if (Number.isNaN(dotIndex)) return;
          goTo(dotIndex);
        });
      });

      videos.forEach((video, i) => {
        if (!video) return;
        video.addEventListener('ended', () => {
          const nextIndex = i + 1;
          if (nextIndex >= cards.length) return;
          goTo(nextIndex);
          attemptPlay(videos[nextIndex]);
        });
      });

      syncDotsFromScroll();
    });
  }

  initExpertOpinionCarousel();

  const animated = document.querySelectorAll('[data-nv-animate]');

  if ('IntersectionObserver' in window && animated.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    animated.forEach((item) => observer.observe(item));
  } else {
    animated.forEach((item) => item.classList.add('is-in-view'));
  }

  const mobileProductMedia = window.matchMedia('(max-width: 979px)');
  const productImages = document.querySelectorAll('[data-nv-product-image]');
  let productObserver;

  function setupProductSwap() {
    if (!productImages.length) return;

    if (productObserver) {
      productObserver.disconnect();
      productObserver = null;
    }

    if (!mobileProductMedia.matches) {
      productImages.forEach((image) => image.classList.remove('is-swapped'));
      return;
    }

    const isSmallMobile = window.matchMedia('(max-width: 760px)').matches;

    productObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-swapped', entry.intersectionRatio >= (isSmallMobile ? 0.82 : 0.5));
      });
    }, { threshold: isSmallMobile ? [0, 0.82, 1] : [0, 0.5, 1] });

    productImages.forEach((image) => productObserver.observe(image));
  }

  setupProductSwap();
  mobileProductMedia.addEventListener('change', setupProductSwap);

  function initBeforeAfterAutoScroll() {
    const mobileBAMedia = window.matchMedia('(max-width: 760px)');
    if (!mobileBAMedia.matches) return;

    document.querySelectorAll('[data-nv-ba-grid]').forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll('.nv-card'));
      if (cards.length < 2) return;

      let index = 0;
      let timer = null;
      let resumeTimeout = null;

      function goTo(nextIndex) {
        index = (nextIndex + cards.length) % cards.length;
        grid.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(() => goTo(index + 1), 3600);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      grid.addEventListener('touchstart', () => {
        stopAuto();
        if (resumeTimeout) clearTimeout(resumeTimeout);
      }, { passive: true });

      grid.addEventListener('touchend', () => {
        if (resumeTimeout) clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(startAuto, 2000);
      }, { passive: true });

      startAuto();
    });
  }

  initBeforeAfterAutoScroll();

  const mobileWhoMedia = window.matchMedia('(max-width: 760px)');
  let whoObserver;

  function getWhoCards() {
    return Array.from(document.querySelectorAll('.nv-who-card'));
  }

  function setupWhoCardsMobile() {
    const whoCards = getWhoCards();

    if (whoObserver) {
      whoObserver.disconnect();
      whoObserver = null;
    }

    if (!mobileWhoMedia.matches) {
      whoCards.forEach((card) => card.classList.remove('is-active'));
      return;
    }

    whoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          whoCards.forEach((card) => {
            if (card !== entry.target) card.classList.remove('is-active');
          });
          entry.target.classList.add('is-active');
        } else {
          entry.target.classList.remove('is-active');
        }
      });
    }, { threshold: 0, rootMargin: '-35% 0px -35% 0px' });

    whoCards.forEach((card) => whoObserver.observe(card));
  }

  function initWhoCards() {
    setupWhoCardsMobile();
  }

  initWhoCards();
  mobileWhoMedia.addEventListener('change', initWhoCards);
  document.addEventListener('shopify:section:load', initWhoCards);
  document.addEventListener('shopify:section:reorder', initWhoCards);

  const newsletterWraps = document.querySelectorAll('[data-nv-newsletter-wrap]');

  newsletterWraps.forEach((wrap) => {
    const form = wrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', () => {
      try {
        // Native submit posts into the hidden iframe (CAPTCHA requires this),
        // so the iframe's response can't be read cross-origin — this is an
        // optimistic UI update, not a confirmation the signup succeeded.
        setTimeout(() => {
          wrap.innerHTML = '<p class="nv-footer-newsletter-sub">' + escHtml("You're on the list.") + '</p>';
        }, 800);
      } catch (err) {
        // no-op
      }
    });
  });
});

function initAnnouncementCountdown() {
  var el = document.querySelector('[data-nv-countdown]');
  if (!el) return;
  var endDate = new Date(el.getAttribute('data-nv-countdown'));
  if (isNaN(endDate.getTime())) return;
  var timeEl = el.querySelector('[data-nv-countdown-time]');

  function tick() {
    var diff = endDate - new Date();
    if (diff <= 0) {
      el.style.display = 'none';
      clearInterval(timer);
      return;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    timeEl.textContent = d > 0
      ? d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s)
      : pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  tick();
  var timer = setInterval(tick, 1000);
}

document.addEventListener('DOMContentLoaded', initAnnouncementCountdown);
